<template>
  <div>
    <table v-if="list.deviceStatusList[0] && list.deviceIsconnected == 3">
      <tr>
        <th>{{ $t("lang.particulars.profileIp") }}</th>
        <td v-if="list.deviceStatusList[0].dsIp">
          {{ list.deviceStatusList[0].dsIp | ipv4Sort }}
        </td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.profilegateway") }}</th>
        <td v-if="list.deviceStatusList[0].dsGateway">
          {{ list.deviceStatusList[0].dsGateway }}
        </td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <!-- <th>{{$t('lang.particulars.profileNonContiguousSubnetMask')}}</th>
              <td v-if="list.deviceStatusList[0].dsNetmask">{{list.deviceStatusList[0].dsNetmask}}</td>
              <td v-else>N/A</td> -->
        <th>{{ $t("lang.particulars.profileNETWORK") }}</th>
        <td v-if="list.deviceStatusList[0].dsProto == 0">PPP</td>
        <td v-else-if="list.deviceStatusList[0].dsProto == 1">DHCP</td>
        <td v-else-if="list.deviceStatusList[0].dsProto == 2">
          {{ $t("lang.particulars.addressStrings") }}
        </td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.profileConnection") }}</th>
        <td v-if="list.deviceStatusList[0].dsIp">
          {{ $t("lang.particulars.connected") }}
        </td>
        <td v-else>{{ $t("lang.particulars.disOpened") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.profileUpdateTime") }}</th>
        <td>{{ list.deviceStatusList[0].dsUpdate }}</td>
      </tr>
      <tr v-if="list.deviceStatusList[0].dsIpv6">
        <th>{{ $t("lang.particulars.wan3g1IPV6") }}</th>
        <td>
          <span>{{ list.deviceStatusList[0].dsIpv6 | ipv6 }}</span>
        </td>
      </tr>
    </table>

    <table v-else>
      <tr>
        <th>{{ $t("lang.particulars.profileIp") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.profilegateway") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.profileNonContiguousSubnetMask") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.profileNETWORK") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.profileConnection") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: ["list"],
  data() {
    return {};
  },
  methods: {},
  filters: {
    ipv6: function(e) {
      let a = e.split("#");
      let html = ``;
      a.forEach((v) => {
        html += `${v}<br>`;
      });
      return html;
    },
    ipv4Sort: function(e) {
      let ipList = e.split(" ")
      ipList = ipList.sort()
      e = ipList.join(" ")
      return e
    },
  },
};
</script>
<style scoped src="./particulars.css"></style>
